import React from 'react'
import DisplayFormatedNumber from '../../../components/DisplayFormatedNumber'

export const getLabelValueWithPrefix = (compensation: number, prefix = '+') => (
  <>
    <span>{prefix}</span>
    <DisplayFormatedNumber value={compensation} format="euroInt" />
  </>
)

export const getLabelValueWithNegativePrefix = (compensation: number, prefix = '-') => (
  <>
    <span>{prefix}</span>
    <DisplayFormatedNumber value={compensation} format="euroInt" />
  </>
)
